import { render, staticRenderFns } from "./TarifHeaderFriends.vue?vue&type=template&id=6e37a9fa"
import script from "./TarifHeaderFriends.vue?vue&type=script&lang=js"
export * from "./TarifHeaderFriends.vue?vue&type=script&lang=js"
import style0 from "./TarifHeaderFriends.vue?vue&type=style&index=0&id=6e37a9fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports